module.exports = __webpack_public_path__ + "static/media/rooney-mara-lose.6d2bc08b.jpg";